import { useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import type { TapeBuilderNodeType } from '@finley-technologies/tape-builder';

export type RenderNodeProps = {
  nodeText: string;
  nodeType: TapeBuilderNodeType;
  selected?: boolean;
  hasInputs?: boolean;
  draggable?: boolean;
  nodeId?: string;
  children?: React.ReactNode;
};

/**
 * Custom hook that provides consistent color values and border sizes for TapeNode and OperationNode
 * components across light and dark modes.
 */
export const useNodeColors = () => {
  const bgColor = useColorModeValue('white', 'gray.700');
  const textColor = useColorModeValue('gray.800', 'white');
  const borderColor = useColorModeValue('gray.500', 'gray.300'); // Lighter green in dark mode for better visibility
  const selectedBorderColor = useColorModeValue('yellow.400', 'yellow.100'); // Bright yellow for visibility
  const iconColor = useColorModeValue('green.500', 'green.300'); // Match border color for consistency

  // Border sizes - consistent across both node types
  const unSelectedBorderSize = '2px';
  const selectedBorderSize = '4px';

  return {
    bgColor,
    textColor,
    borderColor,
    selectedBorderColor,
    iconColor,
    unSelectedBorderSize,
    selectedBorderSize,
  };
};
